import useTower from "helpers/hooks/towers/useTower"
import EntityLink from "widgets/common/EntityLink"

interface SpanTowerLinkProps {
  towerId: number
}

/**
 * One tower of the span, by name. A component per tower rather than a loop:
 * `tower_ids` is a list and a hook cannot be called inside one. `useTowers`
 * would answer in one call but fetches every tower of the organization.
 *
 * The id stands in while the tower loads, and for a tower with no name.
 */
const SpanTowerLink = ({ towerId }: SpanTowerLinkProps) => {
  const { tower } = useTower({ id: towerId })

  return <EntityLink entity="tower" id={towerId} name={tower?.name || String(towerId)} />
}

export default SpanTowerLink
